import {Component, OnInit} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {iif, throwError, timer} from 'rxjs';
import {catchError, filter, finalize, flatMap, switchMap, take, tap} from 'rxjs/operators';
import {environment} from '../../../environments/environment';

import {BeachesService} from '../beaches.service';
import {BaseService} from '@shared/services/base.service';
import {NgForOf, NgIf} from '@angular/common';
import {DisplayPipe} from '@shared/pipes/display.pipe';
import {SearchComponent} from '@shared/search/search.component';
import {DynamicInputComponent} from '@shared/dynamic-input/dynamic-input.component';
import {NestedInlineComponent} from '@shared/inlines/nested/nested-inline.component';
import {ToastService} from '@shared/services/toast.service';
import {ErrorHandlingService} from '@shared/services/error-handling.service';

@Component({
    selector: 'app-beach-organization',
    templateUrl: './beach-organization.component.html',
    styleUrls: ['./beach-organization.component.css'],
    providers: [DisplayPipe],
    imports: [
        SearchComponent,
        DynamicInputComponent,
        NgIf,
        NgForOf,
        NestedInlineComponent
    ]
})
export class BeachOrganizationComponent implements OnInit {
  public loading = false;
  public peopleLoading = false;
  public orderLoading = false;
  public organizationService: BaseService;
  public peopleService: BaseService;
  public criteriaService: BaseService;
  public orderService: BaseService;
  public reportService: BaseService;
  private groupsService: BaseService;
  public orgItem;
  public orgMeta;
  public peopleItem;
  public peopleMeta;
  public criteriaItem;
  public criteriaMeta;
  public orderItem;
  public orderMeta;
  public reportItem;
  public reportMeta;
  private saving = false;
  private hadError = false;
  public reportLoading = false;
  public criteriaLoading = false;
  private westBeachItem: any[];
  private task;

  constructor(http: HttpClient, public toastr: ToastService, private displayPipe: DisplayPipe,
              private errorHandling: ErrorHandlingService, private modalService: NgbModal, public beachService: BeachesService) {
    this.organizationService = new BaseService(`${environment.baseUrl}/beaches/organization`, http);
    this.peopleService = new BaseService(`${environment.baseUrl}/beaches/person`, http);
    this.criteriaService = new BaseService(`${environment.baseUrl}/beaches/criteria`, http);
    this.orderService = new BaseService(`${environment.baseUrl}/beaches/monitoringlocation`, http);
    this.reportService = new BaseService(`${environment.baseUrl}/beaches/reportdistributionlist`, http);
    this.groupsService = new BaseService(`${environment.baseUrl}/beaches/samplinggroups`, http);
  }

  ngOnInit() {
    this.loading = true;
    this.peopleLoading = true;
    this.orderLoading = true;
    this.reportLoading = true;
    this.criteriaLoading = true;
    this.getOrganizations();
    this.getCriteria();
    this.getPeople();
    this.getLocationOrder();
    this.getReports();
    // console.log(this.getPeople());
  }

  getOrganizations() {
    const baseService = this.organizationService;
    baseService.get<any>('0aa31dfb-a5c3-4138-84e4-5df11219f35b').pipe(tap((item) => {
        this.orgItem = item.result;
        this.orgMeta = item.meta;
        this.orgMeta.display_fields = ['name', 'description', 'monitoring_id', 'notification_id', 'abbreviation', 'typecode',
          'telephonenumber', 'telephonetypecode', 'telephoneeffectivedate', 'telephonestatus',
          'electronicaddr', 'electronicaddrtypecode', 'electronicaddreffdate', 'electronicaddrstatus',
          'mailingaddrline1', 'mailingaddrline2', 'mailingaddrtypecode', 'mailingaddrcity', 'statecode', 'zipcode',
          'mailingaddreffectivedate', 'mailingaddrstatus'];
      }),
      finalize(() => {
        // this.save(baseService);
        this.loading = false;
      })).subscribe();
  }

  getPeople() {
    this.peopleLoading = true;
    const baseService = this.peopleService;

    baseService.getList<any>({organization: '0aa31dfb-a5c3-4138-84e4-5df11219f35b'}).pipe(tap((item) => {
        this.peopleItem = item.results;
        this.peopleMeta = item.meta;
        this.peopleMeta.type = 'beaches/person';
        this.peopleMeta.display_fields = ['identifier', 'title', 'first_name', 'middle_initial', 'last_name',
          'suffix', 'is_state_contact', 'status', 'telephone_typecode', 'telephone_number', 'telephone_effective_date',
          'telephone_status', 'electronic_addr_type_code', 'electronic_addr', 'electronic_addr_effdate',
          'electronic_addr_status'
        ];
      }),
      finalize(() => {
        this.peopleLoading = false;
        // this.save(baseService);
      })).subscribe();
  }

  getCriteria() {
    this.criteriaLoading = true;
    const baseService = this.criteriaService;

    baseService.getList<any>({}).pipe(tap((item) => {
        this.criteriaItem = item.results;
        this.criteriaMeta = item.meta;
        this.criteriaMeta.type = 'beaches/criteria';
        this.criteriaMeta.display_fields = [
          'monitoring_location', 'isdefault', 'geo_criteria', 'stv_criteria', 'stv_percent'
        ];
        this.criteriaMeta.fields.monitoring_location.type = 'choice';
        this.criteriaMeta.fields.monitoring_location.choices = [];
        this.orderService.getList<any>({
          page_size: 1000
        }).subscribe((items) => {
          items.results.forEach((location, i) => {
            this.criteriaMeta.fields.monitoring_location.choices.push({
              display_name: location.name + ' (' + location.locationid + ')',
              value: location.globalid,
              id: location.locationid
            });
          });
        });
      }),
      finalize(() => {
        this.criteriaLoading = false;
      })).subscribe();
  }

  getLocationOrder() {
    this.orderLoading = true;
    this.beachService.getList<any>({page_size: 1000, ordering: 'sort_order'}).pipe(tap((response) => {
        this.orderMeta = response.meta;
        this.orderItem = response.results;
        this.orderMeta.type = 'beaches/monitoringlocation';
        this.orderMeta.display_fields = ['name', 'locationid'];
        this.orderMeta.sort_attribute = 'sort_order';
        this.orderMeta.verbose_name_plural = 'Beach Monitoring Locations';
        // this.orderMeta.locations.meta.fields.group.choices = [];
        // this.orderMeta.locations.foreign_key_field =
        // this.orderItem.forEach(item => {
        //   this.orderMeta.locations.meta.fields.group.choices.push({
        //     name: item.groupname,
        //     value: item.globalid
        //   });
        // });
        // const index = this.orderMeta.locations.meta.fields.group.choices.findIndex(x => x.name === 'Unassigned')
        //   if (index === -1) {
        //     this.orderMeta.locations.meta.fields.group.choices.push({name: 'Unassigned'});
        //   }
      }),
      finalize(() => {
        this.orderLoading = false;
        // this.save(baseService);
      })).subscribe();
  }

  getReports() {
    this.reportLoading = true;
    const baseService = this.reportService;

    baseService.getList<any>({page_size: 1000}).pipe(tap((item) => {
        this.reportItem = item.results;
        this.reportMeta = item.meta;
        this.reportMeta.type = 'beaches/reportdistributionlist';
        this.reportMeta.display_fields = [
          'email', 'name'
        ];
        this.reportMeta.verbose_name_plural = 'Beach Report Distribution List';
      }),
      finalize(() => {
        this.reportLoading = false;
      })).subscribe();
  }

  public save(baseService, item) {
    this.errorHandling.customErrorMessage = true;
    this.errorHandling.customSaveMessage = true;
    this.saving = true;
    const saveItem = item;
    iif(() => saveItem.hasOwnProperty('globalid'),
      baseService.put(saveItem.globalid, saveItem),
      baseService.post(saveItem)).pipe(catchError((error: any) => {
      if (error) {
        this.hadError = true;
        return throwError(error);
      } else {
        this.hadError = false;
      }
    })).subscribe(() => {
        this.toastr.success('Succesfully saved.');
        this.errorHandling.customErrorMessage = false;
      },
      () => {
        if (this.hadError) {
          this.hadError = false;
          this.toastr.error('Error');
        }
        // switch back to false so it doesn't prevent default error message
        this.errorHandling.customErrorMessage = false;
      });
  }

  submitSurveyFeatures(items) {
    // const featureJSON = [];
    // items.forEach(item => {
    //   featureJSON.push({
    //    geometry: {y: item.latitude, x: item.longitude},
    //   attributes: {
    //       monitoring_location: item.globalid, site_name: item.name, site_id: item.id,
    //       sample_collection_methodid: 'GRAB-' + item.id
    //     }
    //   });
    // });
    // Object.entries(featureJSON);
    this.orderService.customPOST('submit_survey', items).pipe(tap((response) => {
        this.task = response;
      }),
      flatMap(() => this.getTaskStatus(this.task))).subscribe();
    //   return timer(0, 1000).pipe(
    //     switchMap(_ => this.genericService.taskstatus(this.task)),
    //      map(res => {
    //     if (res.error) {
    //       throw new Error(res.error.toString());
    //     } else {
    //       return res;
    //     }
    //   }),
    //     filter(response => response.success === true),
    //     take(1),
    //      catchError(error => of(this.toastr.error('Error sending survey templates'))),
    //     finalize(() => of(console.log('Successfully sent survey templates.'))));
  }

  getTaskStatus(taskId) {
    // const taskURL = this.taskService.taskstatus(this.task);
    return timer(0, 1000).pipe(
      switchMap(_ => this.orderService.customPOST('task_status', {id: taskId.response.id})),
      filter(response => response[0] === true),
      take(1),
      finalize(() => this.toastr.success('Successfully sent survey templates.')));
  }
}

// /*global angular */
// var id = '0AA31DFB-A5C3-4138-84E4-5DF11219F35B';
// angular.module('app')
//     .controller('OrganizationController', ['$scope', 'Restangular', '$uibModal',
//         function ($scope, Restangular, $uibModal) {
//             'use strict';
//             $scope.loading = true;
//
//             Restangular.one('beaches/organization', '{482FC043-112B-4457-9550-1A13FEBC0241}').get().then(function (item) {
//                 $scope.item = item;
//                 $scope.meta = item.meta;
//
//                 $scope.meta.display_fields = ['name', 'description', 'monitoring_id', 'notification_id', 'abbreviation', 'typecode',
//                     'telephonenumber', 'telephonetypecode', 'telephoneeffectivedate', 'telephonestatus',
//                     'electronicaddr', 'electronicaddrtypecode', 'electronicaddreffdate', 'electronicaddrstatus',
//                     'mailingaddrline1', 'mailingaddrline2', 'mailingaddrtypecode', 'mailingaddrcity', 'statecode', 'zipcode',
//                     'mailingaddreffectivedate', 'mailingaddrstatus'];
//             }).finally(function () {
//                 $scope.loading = false;
//             });
//
//             $scope.save = function () {
//                 $scope.item.save();
//             };
//         }])
//     .controller('PersonController', ['$scope', 'Restangular',
//         function ($scope, Restangular) {
//             'use strict';
//             $scope.loading = true;
//
//             Restangular.all('beaches/person').getList({search: '0AA31DFB-A5C3-4138-84E4-5DF11219F35B'}).then(function (items) {
//                 $scope.items = items;
//                 $scope.meta = items.meta;
//                 $scope.meta.type = 'beaches/person';
//                 $scope.meta.display_fields = ['identifier', 'title', 'first_name', 'middle_initial', 'last_name',
//                     'suffix', 'is_state_contact', 'status', 'telephone_typecode', 'telephone_number', 'telephone_effective_date',
//                     'telephone_status', 'electronic_addr_type_code', 'electronic_addr', 'electronic_addr_effdate',
//                     'electronic_addr_status'
//                 ];
//             }).finally(function () {
//                 $scope.loading = false;
//             });
//         }])
//     .controller('CriteriaController', ['$scope', 'Restangular',
//         function ($scope, Restangular) {
//             'use strict';
//             $scope.loading = true;
//
//             Restangular.all('beaches/criteria').getList().then(function (items) {
//                 $scope.items = items;
//                 $scope.meta = items.meta;
//                 $scope.meta.type = 'beaches/criteria';
//                 $scope.meta.display_fields = [
//                     'geo_criteria', 'stv_criteria', 'stv_percent', 'monitoring_location', 'isdefault'
//                 ];
//                 $scope.meta.fields.monitoring_location.type = 'choice';
//                 $scope.meta.fields.monitoring_location.choices = [];
//                 Restangular.all('beaches/monitoringlocation').getList({
//                     page_size: 1000
//                 }).then(function (items) {
//                     angular.forEach(items, function (location, i) {
//                         $scope.meta.fields.monitoring_location.choices.push({
//                             display_name: location.name + ' (' + location.id + ')',
//                             value: location.globalid,
//                             id: location.id
//                         });
//                     });
//                 });
//             }).finally(function () {
//                 $scope.loading = false;
//             });
//         }])
//     .controller('LocationOrderingController', ['$scope', 'Restangular',
//         function ($scope, Restangular) {
//             $scope.loading = true;
//
//             Restangular.all('beaches/monitoringlocation').getList({page_size: 1000, ordering:'sort_order'}).then(function (items) {
//                 $scope.items = items;
//                 $scope.meta = items.meta;
//                 $scope.meta.type = 'beaches/monitoringlocation';
//                 $scope.meta.display_fields = [
//                     'name', 'id'
//                 ];
//                 $scope.meta.sort_attribute = 'sort_order';
//                 $scope.meta.verbose_name_plural = 'Beach Monitoring Location Default Sort Order';
//             }).finally(function () {
//                 $scope.loading = false;
//             });
//         }])
//     .controller('ReportDistributionController', ['$scope', 'Restangular',
//         function ($scope, Restangular) {
//             'use strict';
//             $scope.loading = true;
//
//             Restangular.all('beaches/reportdistributionlist').getList({page_size: 1000}).then(function (items) {
//                 $scope.items = items;
//                 $scope.meta = items.meta;
//                 $scope.meta.type = 'beaches/reportdistributionlist';
//                 $scope.meta.display_fields = [
//                     'email', 'name'
//                 ];
//                 $scope.meta.verbose_name_plural = 'Beach Report Distribution List';
//             }).finally(function () {
//                 $scope.loading = false;
//             });
//         }]);
